import { supabase } from '../client/supabaseClient';

/**
 * Fetches shop details by ID from the database.
 * Calls the 'fetch_shop_details' RPC in the 'api' schema.
 * 
 * @param shopId - The ID of the shop to fetch details for
 * @returns Shop details including name, address, etc.
 */
export async function fetchShopDetails(shopId: string) {
    try {
        const { data, error } = await supabase
            .schema('api')
            .rpc('fetch_shop_details', { shop_id: shopId });

        if (error) {
            console.error('Error fetching shop details:', error);
            return null;
        }

        return data; // Returns shop details object
    } catch (error) {
        console.error('Unexpected error in fetchShopDetails:', error);
        return null;
    }
}
